// extracted by mini-css-extract-plugin
export var showMoreIcon = "styles-module--showMore-icon--ede28";
export var showMoreText = "styles-module--showMore-text--fa3cf";
export var showMoreWrapper = "styles-module--showMore-wrapper--cee3d";
export var suptitle = "styles-module--suptitle--62bda";